import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import consola from 'consola';
import productQuery from '~/graphql/product.gql';
import productVariantsQuery from '~/graphql/product/variants.gql';
import productImagesQuery from '~/graphql/product/images.gql';
import productsQuery from '~/graphql/products.gql';
import productCarouselsQuery from '~/graphql/product/carousels.gql';
import productOffersQuery from '~/graphql/product/offers.gql';

function fetchProductCarousels(_x, _x2) {
  return _fetchProductCarousels.apply(this, arguments);
}

function _fetchProductCarousels() {
  _fetchProductCarousels = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(context, reference) {
    var profileId,
        exclude,
        useLatest,
        locale,
        _ref5,
        data,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            profileId = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            exclude = _args.length > 3 ? _args[3] : undefined;
            useLatest = _args.length > 4 ? _args[4] : undefined;
            locale = context.state.i18n.currentLocale.iso;
            _context.prev = 4;
            _context.next = 7;
            return context.app.apolloProvider.defaultClient.query({
              query: productCarouselsQuery,
              variables: {
                profileId: profileId,
                reference: reference,
                locale: locale,
                exclude: exclude,
                useLatest: useLatest
              }
            });

          case 7:
            _ref5 = _context.sent;
            data = _ref5.data;
            return _context.abrupt("return", data.product);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            consola.error(_context.t0);
            return _context.abrupt("return", null);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 12]]);
  }));
  return _fetchProductCarousels.apply(this, arguments);
}

function fetchProduct(_x3, _x4, _x5) {
  return _fetchProduct.apply(this, arguments);
}

function _fetchProduct() {
  _fetchProduct = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(context, reference, offer) {
    var profileId,
        useLatest,
        locale,
        _ref6,
        data,
        _args2 = arguments;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            profileId = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
            useLatest = _args2.length > 4 ? _args2[4] : undefined;
            locale = context.state.i18n.currentLocale.iso;
            _context2.prev = 3;
            _context2.next = 6;
            return context.app.apolloProvider.defaultClient.query({
              query: productQuery,
              variables: {
                locale: locale,
                reference: reference,
                offer: offer,
                profileId: profileId,
                useLatest: useLatest
              }
            });

          case 6:
            _ref6 = _context2.sent;
            data = _ref6.data;
            return _context2.abrupt("return", data.product);

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](3);
            consola.error(_context2.t0);
            return _context2.abrupt("return", null);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 11]]);
  }));
  return _fetchProduct.apply(this, arguments);
}

function fetchProductVariants(_x6, _x7) {
  return _fetchProductVariants.apply(this, arguments);
}

function _fetchProductVariants() {
  _fetchProductVariants = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(_ref, reference) {
    var app, getters, locale, _ref7, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            app = _ref.app, getters = _ref.getters;
            locale = getters['i18n/locale'].iso;
            _context3.prev = 2;
            _context3.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productVariantsQuery,
              variables: {
                reference: reference,
                locale: locale
              }
            });

          case 5:
            _ref7 = _context3.sent;
            data = _ref7.data;
            return _context3.abrupt("return", data.product);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            consola.error(_context3.t0);
            return _context3.abrupt("return", null);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 10]]);
  }));
  return _fetchProductVariants.apply(this, arguments);
}

function fetchProductImages(_x8, _x9) {
  return _fetchProductImages.apply(this, arguments);
}

function _fetchProductImages() {
  _fetchProductImages = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(_ref2, reference) {
    var app, getters, locale, _ref8, data;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            app = _ref2.app, getters = _ref2.getters;
            locale = getters['i18n/locale'].iso;
            _context4.prev = 2;
            _context4.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productImagesQuery,
              variables: {
                reference: reference,
                locale: locale
              }
            });

          case 5:
            _ref8 = _context4.sent;
            data = _ref8.data;
            return _context4.abrupt("return", data.product);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](2);
            consola.error(_context4.t0);
            return _context4.abrupt("return", null);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 10]]);
  }));
  return _fetchProductImages.apply(this, arguments);
}

function fetchProducts(_x10, _x11) {
  return _fetchProducts.apply(this, arguments);
}

function _fetchProducts() {
  _fetchProducts = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(_ref3, references) {
    var app, getters, locale, _ref9, data;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            app = _ref3.app, getters = _ref3.getters;
            locale = getters['i18n/locale'].iso;
            _context5.prev = 2;
            _context5.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productsQuery,
              variables: {
                locale: locale,
                references: references
              }
            });

          case 5:
            _ref9 = _context5.sent;
            data = _ref9.data;
            return _context5.abrupt("return", data.products);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](2);
            consola.error(_context5.t0);
            return _context5.abrupt("return", null);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 10]]);
  }));
  return _fetchProducts.apply(this, arguments);
}

function fetchProductOffers(_x12, _x13, _x14) {
  return _fetchProductOffers.apply(this, arguments);
}

function _fetchProductOffers() {
  _fetchProductOffers = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee6(_ref4, reference, useLatest) {
    var app, getters, locale, _ref10, data;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            app = _ref4.app, getters = _ref4.getters;
            locale = getters['i18n/locale'].iso;
            _context6.prev = 2;
            _context6.next = 5;
            return app.apolloProvider.defaultClient.query({
              query: productOffersQuery,
              variables: {
                reference: reference,
                locale: locale,
                useLatest: useLatest
              }
            });

          case 5:
            _ref10 = _context6.sent;
            data = _ref10.data;
            return _context6.abrupt("return", data.product);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](2);
            consola.error(_context6.t0);
            return _context6.abrupt("return", null);

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[2, 10]]);
  }));
  return _fetchProductOffers.apply(this, arguments);
}

export { fetchProduct, fetchProductCarousels, fetchProductVariants, fetchProductImages, fetchProductOffers, fetchProducts };